import React from 'react';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import AddFreeHypothesisEntryForm from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/AddFreeHypothesisEntryForm';
import { useFreeHypothesisPostMutation } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/hooks/freeHypothesis';
import {
    FreeHypothesis,
    FreeHypothesisEditMutationParams,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import FreeHypothesesDisplay from './components/informationDisplay/FreeHypothesesDisplay';
import { CostPerYearT } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/GVTData/helpers/hooks/gvtData';

type Props = {
    hrSimulation: HrSimulation;
    freeHypothesisData: FreeHypothesis[];
    freeHypothesisTotal: Record<string, number>;
    freeHypothesisPerYear: Record<string, CostPerYearT>;
    setFreeHypothesisUpdatePayload: (
        payload: FreeHypothesisEditMutationParams,
    ) => void;
    hasChange: () => void;
};
const FreeHypothesisEntryForm = ({
    hrSimulation,
    freeHypothesisData,
    freeHypothesisTotal,
    freeHypothesisPerYear,
    setFreeHypothesisUpdatePayload,
    hasChange,
}: Props) => {
    const { mutate: createFreeHypothesis } = useFreeHypothesisPostMutation({
        hrSimulationId: hrSimulation.id,
    });
    return (
        <>
            {freeHypothesisData.length > 0 ? (
                <FreeHypothesesDisplay
                    freeHypotheses={freeHypothesisData}
                    hrSimulation={hrSimulation}
                    freeHypothesisTotal={freeHypothesisTotal}
                    freeHypothesisPerYear={freeHypothesisPerYear}
                    createFreeHypothesis={createFreeHypothesis}
                    setFreeHypothesisUpdatePayload={
                        setFreeHypothesisUpdatePayload
                    }
                    hasChange={hasChange}
                />
            ) : (
                <AddFreeHypothesisEntryForm
                    hrSimulation={hrSimulation}
                    createFreeHypothesis={createFreeHypothesis}
                    hasChange={hasChange}
                />
            )}
        </>
    );
};

export default FreeHypothesisEntryForm;
